import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

function PaymentSuccess() {

const query = new URLSearchParams(useLocation().search);

const bookingId = query.get("bookingId");

const [invoiceLink, setInvoiceLink] = useState("");
const [loading, setLoading] = useState(true);

useEffect(() => {


const confirmPayment = async () => {

  try {

    const res = await axios.post(
      `${window.APP_CONFIG.BACKEND_URI}/payment/payment-success`,
      {
        bookingMongoId: bookingId
      }
    );

    setInvoiceLink(res.data.invoiceLink);
    setLoading(false);

  } catch (err) {
    console.error(err);
    setLoading(false);
  }

};

if (bookingId) {
  confirmPayment();
}


}, [bookingId]);

return (
<div style={{ padding: "40px", textAlign: "center" }}>


  <h2>✅ Payment Successful</h2>

  {loading && <p>Confirming payment...</p>}

  {!loading && (
    <>
      <p>Your booking has been confirmed.</p>

      {invoiceLink && (
        <a
          href={invoiceLink}
          target="_blank"
          rel="noreferrer"
          style={{
            padding: "12px 20px",
            background: "#2c7be5",
            color: "#fff",
            borderRadius: "6px",
            textDecoration: "none"
          }}
        >
          Download Invoice
        </a>
      )}
    </>
  )}

</div>


);
}

export default PaymentSuccess;